import { useState } from 'react';
import { useLocation } from 'react-router';
import { devSignInUrl, isLoopback, signInUrl } from '@/api/session';
import { Button, Field, Kicker, TextInput } from '@/ui/primitives';

/**
 * One link. No role picker, no password: who somebody is and which
 * departments they hold are resolved by the gateway from Google's word, and
 * the interface learns them from `/auth/me` afterwards.
 *
 * On a loopback host a second door appears: the development sign-in, which
 * the gateway serves only when it was itself told it is local
 * (`apps/gateway/src/local.ts`). A deployed interface never shows it.
 */
export function SignIn() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const returnTo = params.get('returnTo') ?? '/';
  const local = isLoopback(window.location.hostname);
  const [email, setEmail] = useState('iryna@norumfoods.com');

  return (
    <main className="flex min-h-screen items-center justify-center bg-page p-6">
      <div className="flex w-full max-w-[420px] flex-col gap-6 rounded-brand border border-line p-8">
        <div className="flex flex-col gap-2">
          <Kicker>Norum</Kicker>
          <h1 className="m-0 text-screen font-semibold leading-tight">Sign in</h1>
          <p className="m-0 text-body text-secondary">
            With your Norum Workspace account. Everything you can reach is decided by the
            departments you hold.
          </p>
        </div>
        <a
          href={signInUrl(returnTo)}
          className="flex min-h-tap items-center justify-center rounded-brand border border-strong bg-[var(--btn-bg)] px-5 text-label uppercase tracking-button text-[var(--btn-fg)] no-underline hover:bg-[var(--btn-bg-hover)]"
        >
          Continue with Google
        </a>
        <p className="m-0 text-dense text-meta">Only @norumfoods.com accounts can sign in.</p>

        {local && (
          <form
            className="flex flex-col gap-3 border-t border-line pt-5"
            onSubmit={(e) => {
              e.preventDefault();
              window.location.assign(devSignInUrl(email, returnTo));
            }}
          >
            <Kicker>Local only · no Google</Kicker>
            <Field label="Sign in as" hint="Somebody the local platform knows. The gateway resolves them through core-api exactly as a real sign-in does.">
              <TextInput
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-label="Email to sign in as"
              />
            </Field>
            <Button icon="open" type="submit" variant="secondary" data-testid="dev-sign-in">Open a local session</Button>
          </form>
        )}
      </div>
    </main>
  );
}

export function Booting() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-page">
      <Kicker>Loading</Kicker>
    </main>
  );
}
